import React from 'react';
import './ContributorMapsSection.css';

const ContributorAttributionBanner = ({ mapData, onClose }) => {
  if (!mapData) return null;

  return (
    <div className="contributor-attribution-banner">
      <div className="attribution-content">
        <img
          src={mapData.contributorAvatar}
          alt={mapData.contributorName}
          className="attribution-avatar"
        />
        <div className="attribution-text">
          <h3 className="attribution-title">
            Viewing: {mapData.mapTitle}
          </h3>
          <p className="attribution-creator">
            Curated by {mapData.contributorName}
          </p>
        </div>
        <button
          className="attribution-close"
          onClick={onClose}
        >
          View All →
        </button>
      </div>
    </div>
  );
};

export default ContributorAttributionBanner;
